import CustomersList from "../../components/customersPage/customersList";
import DashboardLayout from "../../layout";

const Customers = () => {
  return (
    <DashboardLayout>
      <CustomersList />
    </DashboardLayout>
  );
};

export default Customers;
